export const shouldLoad = () =>
	document.querySelector('[data-controller="tablist"]') !== undefined;
